import {parseToken} from "./UtilityService";

export const getPodcastData = (params) => {
    const {token = ''} = params;

    return parseToken(token);
};

export default {
    getPodcastData
};


